import {configureStore, combineReducers} from "@reduxjs/toolkit";
import {authSlice} from "./slices/authSlice";
import {snackbarSlice} from "./slices/snackbarSlice";
import {i18nSlice} from "./slices/i18nSlice";
import {setupListeners} from "@reduxjs/toolkit/query";
import {api} from "@core/api";
import appSlice from "./slices/appSlice";
import {eventSlice} from "./slices/notificationsSlice";

const staticReducers = {
  app: appSlice.reducer,
  notifications: eventSlice.reducer,
  auth: authSlice.reducer,
  snackbar: snackbarSlice.reducer,
  i18n: i18nSlice.reducer,
  [api.reducerPath]: api.reducer,
};

const dynamicReducers: Record<string, any> = {};

const createRootReducer = () =>
  combineReducers({
    ...staticReducers,
    ...dynamicReducers,
  });

export const store = configureStore({
  reducer: createRootReducer(),
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(api.middleware),
});

// Funzione per aggiungere reducer a runtime
export const addReducer = (key: string, reducer: any) => {
  if (!dynamicReducers[key]) {
    dynamicReducers[key] = reducer;
    store.replaceReducer(createRootReducer());
  }
};

// Tipi per lo store
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Configura RTK Query
setupListeners(store.dispatch);
